<wl-content-section [id]="id()" [theme]="theme()">
  <wl-generic-form-section [rendering]="rendering()" />
</wl-content-section>
